import React, { Component } from 'react';
import { compose, pathOr, path, assocPath } from 'ramda';
import Translate from 'react-translate-component';

import XMLFields from './XMLFields';

const fieldsXML = [
    { name: 'MainData.INTDATE', label: 'INTDATE', type: "DatePicker" },
    { name: 'MainData.ZAKNAME', label: 'ZAKNAME', disabled: true, type: "Input" },
    { name: 'MainData.CANDNAME', label: 'CANDNAME', disabled: true, type: "Input" },
    { name: 'MainData.POSNAME', label: 'POSNAME', maxLength: "127", type: "Input" },
    { name: 'MainData.ZAKINFO', label: 'ZAKINFO', maxLength: "1023" },
    { name: 'MainData.CANDINFO', label: 'CANDINFO', maxLength: "1023" },
];

export default class Client extends Component {
    componentDidMount() {
        const { event } = this.props;

        if (event && event.details) {
            const { details, position } = event;

            setTimeout(() => {
                this.props.form.change('result.xmlbody.MainData.INTDATE', details.eventDate);
                this.props.form.change('result.xmlbody.MainData.POSNAME', position);
                this.props.form.change('result.xmlbody.MainData.CANDNAME', pathOr('', ['people', 0, 'text'], details));
                this.props.form.change('result.xmlbody.MainData.ZAKNAME', pathOr('', ['contact', 0, 'text'], details));
            }, 0);
        }
    }

    render () {
        const view = path(['event', 'view'], this.props);

        const fields = view ? (
            compose(
                assocPath([1, 'text'], view.soispstr),
                assocPath([4, 'text'], (
                    <Translate content="xml.PplZakInterv.CONTINFO" with={{ label: view.soispstr }} />
                )),
            )(fieldsXML)
         ) : fieldsXML;

        return (
            <div>
                <XMLFields fieldsXML={fields} translatePrefix="PplZakInterv"/>
            </div>
        );
    }
}
